
import { Component, Prop, Vue } from 'vue-property-decorator';
import { CDNVhostInterface } from '@/services/Vhost/CDN/Interfaces';
import Themeable from 'vuetify/lib/mixins/themeable';

@Component({
  mixins: [
    Themeable,
  ],
})
export default class EditVhostDialog extends Vue {
  @Prop() private readonly vhost!: CDNVhostInterface;

  @Prop() private readonly onEdit!: CallableFunction;

  private edited: CDNVhostInterface = this.vhost;

  private visible: boolean = true;

  private async saveChanges(): Promise<void> {
    await this.onEdit(this.edited);

    this.destroyComponent();
  }

  private destroyComponent(): void {
    this.$emit('close');
  }
}
